import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from 'questionizer-core'
import styles from './index.scss?inline'

//let config = document!.querySelector('meta[name="febis-questionizer-config-url"]')?.getAttribute('content');
import config from './config.json';
if (config !== undefined) {
  const host = document.getElementById('febis-questionizer');
  if (host){
    const shadow = host.attachShadow({ mode: 'open' });
    const mountPoint = document.createElement('div');
    
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styles);
    shadow.adoptedStyleSheets = [sheet];

    console.log("ADOPTED",sheet,  shadow.adoptedStyleSheets);

    shadow.appendChild(mountPoint);

      ReactDOM.createRoot(mountPoint).render(
      <React.StrictMode>
        <App config={config}/>
      </React.StrictMode>);
    }
  }else{
    console.warn("Keine Konfiguration gefunden");
  }